import React, { FC, useContext } from 'react';
import { Popup } from 'devextreme-react/popup';
import { HeadingItem } from 'components';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { TripContext } from 'contexts'
import './returnauthorization-popup.scss';
import { Order, ReturnItem } from 'services/types';

type Props = {
    isVisible: boolean,
    title: string,
    stopId: number,
    onClickCloseButton: () => void
}

export const ReturnAuthorizationPopup: FC<Props> = ({ isVisible, title, stopId, onClickCloseButton }) => {

    const tripContext = useContext(TripContext)

    const orders: Order[] = tripContext.orders.filter(lp => lp.stopId === stopId) ?? []
    const returnItems: ReturnItem[] = tripContext.returnItems.filter(returnItem => orders.some(order => order.id === returnItem.orderId))
    const returnAuthorizations: Order[] = tripContext.orders.filter(order => returnItems.some(rtn => rtn.orderId === order.id))

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={300}
            height={450}
        >
            <div className="confirmation-popup-card">
                <HeadingItem text={title} rightHandIcon={{ icon: faTimesCircle, size: '2x', color: 'black' }} onClick={onClickCloseButton} />
                {returnAuthorizations.map(rtn => 
                    <div className={'returnauthorization-popup-content'} key={rtn.id}> {rtn.orderNumber} </div>
                )}
            </div>
        </Popup>
    )
}